/* [PATCH nastavitve-zavihki v1] vrstica zavihkov — isti slog kot SifrantiPage (66-77).
   Prop "desno" izrise poljubno vsebino (npr. gumb Shrani) na desni strani vrstice. */
import React from 'react';
import clsx from 'clsx';

export type Zavihek = { id: string; label: string; icon?: React.ComponentType<{ className?: string }> };

export function Zavihki({ zavihki, aktiven, onIzberi, desno }: {
  zavihki: Zavihek[];
  aktiven: string;
  onIzberi: (id: string) => void;
  desno?: React.ReactNode;
}) {
  return (
    <div className="flex items-center justify-between gap-2 flex-wrap">
      <div className="flex gap-2 flex-wrap">
        {zavihki.map(z => {
          const Icon = z.icon;
          return (
            <button key={z.id} type="button" onClick={() => onIzberi(z.id)}
              className={clsx('flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium border transition',
                aktiven === z.id
                  ? 'bg-blue-600 text-white border-blue-600'
                  : 'bg-white dark:bg-gray-900 text-gray-600 dark:text-gray-400 border-gray-200 dark:border-gray-700 hover:border-blue-400')}>
              {Icon && <Icon className="w-4 h-4" />}{z.label}
            </button>
          );
        })}
      </div>
      {desno}
    </div>
  );
}
